var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaseHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.98 5.8125H11.98C12.1533 5.8125 12.2967 5.75938 12.41 5.65313C12.5233 5.54688 12.58 5.4125 12.58 5.25C12.58 5.0875 12.5233 4.95312 12.41 4.84687C12.2967 4.74062 12.1533 4.6875 11.98 4.6875H3.98C3.80667 4.6875 3.66333 4.74062 3.55 4.84687C3.43667 4.95312 3.38 5.0875 3.38 5.25C3.38 5.4125 3.43667 5.54688 3.55 5.65313C3.66333 5.75938 3.80667 5.8125 3.98 5.8125ZM3.98 8.8125H8.78C8.95333 8.8125 9.09667 8.75938 9.21 8.65313C9.32333 8.54688 9.38 8.4125 9.38 8.25C9.38 8.0875 9.32333 7.95312 9.21 7.84687C9.09667 7.74062 8.95333 7.6875 8.78 7.6875H3.98C3.80667 7.6875 3.66333 7.74062 3.55 7.84687C3.43667 7.95312 3.38 8.0875 3.38 8.25C3.38 8.4125 3.43667 8.54688 3.55 8.65313C3.66333 8.75938 3.80667 8.8125 3.98 8.8125ZM1.2 12C0.88 12 0.6 11.8844 0.36 11.6531C0.12 11.4219 0 11.1625 0 10.875V1.125C0 0.8375 0.12 0.578125 0.36 0.346875C0.6 0.115625 0.88 0 1.2 0H6.3C6.46 0 6.61667 0.03125 6.77 0.09375C6.92333 0.15625 7.05333 0.2375 7.16 0.3375L8 1.125H14.8C15.1067 1.125 15.3833 1.24063 15.63 1.47188C15.8767 1.70313 16 1.9625 16 2.25V10.875C16 11.1625 15.8767 11.4219 15.63 11.6531C15.3833 11.8844 15.1067 12 14.8 12H1.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseHome);
export default __webpack_public_path__ + "static/media/case-home.7d68df8eadc8220e8199a7e0d569f145.svg";
export { ForwardRef as ReactComponent };